/*
 * Copyright (c) 2021-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';

import PropTypes from 'prop-types';
import DialogButton from "./DialogButton.jsx";
import {motion} from "motion/react";
import CloseButton from "../CloseButton.jsx";


class PopOverComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let {uiId, isOpen} = this.props

        return (
            <div className="fixed z-10 inset-0 overflow-hidden"
                 aria-labelledby="modal-title" role="dialog" aria-modal="true">
                <div
                    className="flex items-end justify-center min-h-screen pt-4 px-4  text-center sm:block sm:p-0">

                    {/*Gray out the background of the Page*/}
                    {(this.props.withBackgroundOverlay && isOpen) && (<motion.div
                            initial={{opacity: 0}}
                            animate={{opacity: 0.4}}
                            exit={{opacity: 0}}
                            className={`absolute inset-0 bg-gray-500 w-full h-full transition-all ease-in-out -z-30 duration-300 ${this.props.withBackgroundOverlay ? ("pointer-events-none ") : ("")}  `}
                            aria-hidden="true"/>
                    )}


                    <motion.div
                        key={uiId}
                        initial={{y: 100, opacity: 0.4}}
                        animate={{
                            y: 0,
                            opacity: 1,

                        }}
                        exit={{
                            y: 100,
                            opacity: 0
                        }}
                        transition={{type: "spring", stiffness: 150, damping: 10}}
                        style={{height: "80vh", width: "80vw"}}
                        className={`z-10 inline-block align-bottom bg-white mt-16 rounded-md text-left overflow-hidden shadow-xl transform transition-all sm:align-middle  `}
                    >

                        <div className={"flex flex-col  h-full overflow-hidden"}>
                            <div className="pl-6 border-b  h-14">
                                <div className="flex items-start justify-between py-4 ">
                                    <h2
                                        className="text-base font-semibold text-gray-900 truncate">
                                        {this.props.title}
                                    </h2>
                                    <CloseButton onClick={() => {
                                        // this is a bigger target for the close button to make it easey to hit
                                        if (this.props.onClose !== undefined) {
                                            this.props.onClose()
                                        }
                                    }}/>
                                </div>
                            </div>

                            <div
                                className="bg-white   px-4 pt-5 pb-4 sm:p-6 sm:pb-4 flex flex-grow overflow-hidden">
                                {this.props.children}
                            </div>
                            <DialogButton button={this.props.button}/>

                        </div>


                    </motion.div>
                </div>

            </div>
        )
    };
}

export default PopOverComponent;

PopOverComponent.propTypes = {

    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.array,
    ]),
    /**
     * Bool value to open the panel
     * @default false
     */
    isOpen: PropTypes.bool,

    title: PropTypes.string,
    /**
     * A Bool value to decide weather the left still should be still usable if the panel is open
     * @default false
     */
    withBackgroundOverlay: PropTypes.bool,
    onClose: PropTypes.func,
    /**
     * The height of the modal
     * @default "900px"
     */
    height: PropTypes.string,
    /**
     * The width of the modal
     * @default "60%"
     */
    width: PropTypes.string,
}

PopOverComponent.defaultProps = {
    title: 'Panel title',
    height: '900px',
    width: '60%',
    isOpen: false,
    withBackgroundOverlay: false,
}